// * Toast for Notification
import { toast } from 'react-toastify'
// * Constants helpers
import { AUTH_TOKEN, CSRF_TOKEN } from '../constants/constant'
// * APIs

import jwt_decode from 'jwt-decode'

export default function validateEmail(email) {
  // eslint-disable-next-line no-useless-escape
  const emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/
  return emailReg.test(email)
}

// ** Auth Token Helpers
export const getToken = () => {
  return null
}

export const setToken = (token) => {
  // Deprecated: Auth is handled exclusively via HttpOnly cookies
}

export const removeToken = () => {
  // Deprecated: Auth is handled exclusively via HttpOnly cookies
}

// ** CSRF Token Helpers
export const setCSRFToken = (token) => {
  if (token) {
    localStorage.setItem(CSRF_TOKEN, token)
  }
}

export const getCSRFToken = () => {
  return localStorage.getItem(CSRF_TOKEN)
}

export const removeCSRFToken = () => {
  localStorage.removeItem(CSRF_TOKEN)
}

export const getUserInfo = () => {
  return null
}

export const getUserRole = () => {
  return null
}

export const getUserLevel = () => {
  return null
}

export const getUserId = () => {
  return null
}

// * Function to validate the image
export const validateImage = (image) => {
  if (image) {
    if (image.type === 'image/jpeg' || image.type === 'image/jpg' || image.type === 'image/png') {
      return true
    } else {
      toast.error('Only jpeg, jpg, png formats are allowed', {
        position: toast.POSITION.BOTTOM_RIGHT,
      })
      return false
    }
  }
}

// * Function to create the form data (Used in Add News , Edit News APIs)
export function multiPartData(data, type = '') {
  let multiPart = new FormData()
  for (let key in data) {
    if (type === 'multiple' && key === 'blogImage') {
      data[key].forEach((file) => {
        multiPart.append(key, file)
      })
    } else if (key !== 'blogImage') {
      multiPart.append(key, data[key])
    }
  }

  return multiPart
}

// * Function to Format the data
// * 👇️👇️👇️ Format Date as yyyy-mm-dd hh:mm:ss
export function formatDate(date) {
  return [date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate())].join(
    '-',
  )
}

// 👇️ (Helper functions)
function padTo2Digits(num) {
  return num.toString().padStart(2, '0')
}
